export { default } from './InternalLinkMod';
